import { deleteRest, get, post, put } from 'utils/rxfetch'

import mockCreditManagementAPI from './mockCreditManagementAPI'

const USE_MOCK_API = false

const buildQuery = (companyId) => {
  if (!companyId) return ''
  return `?companyFilter=${encodeURIComponent(companyId)}`
}

const realAPI = {
  getOverview(companyId = '', dateRange = [], timezone = undefined) {
    return post(`/members-api/creditmanagement/overview/${buildQuery(companyId)}`, {
      date_range: dateRange,
      timezone,
    })
  },

  getHistoryLog(companyId = '', payload = {}) {
    return post(`/members-api/creditmanagement/history-log/${buildQuery(companyId)}`, payload)
  },

  getBillingStatus(companyId = '') {
    return get(`/members-api/creditmanagement/billing/status/${buildQuery(companyId)}`)
  },

  getInvoices(companyId = '', { sortBy = 'date', sortDir = 'desc' } = {}) {
    const params = new URLSearchParams()
    if (companyId) params.set('companyFilter', companyId)
    if (sortBy) params.set('sort_by', sortBy)
    if (sortDir) params.set('sort_dir', sortDir)
    const query = params.toString()
    return get(`/members-api/creditmanagement/billing/invoices/${query ? `?${query}` : ''}`)
  },

  getPricing(companyId = '') {
    return post(`/members-api/creditmanagement/pricing/${buildQuery(companyId)}`, {})
  },

  getSetupIntent(companyId = '') {
    return post(`/members-api/creditmanagement/setup-intent/${buildQuery(companyId)}`, {})
  },

  createPortalSession(companyId = '') {
    return post(`/members-api/creditmanagement/billing/portal-session/${buildQuery(companyId)}`, {})
  },

  getCheckoutSession(sessionId, companyId = '') {
    return post(`/members-api/creditmanagement/checkout-session/${buildQuery(companyId)}`, {
      session_id: sessionId,
    })
  },

  updateMonthlyLimit(monthlyLimit, companyId = '') {
    return put(`/members-api/creditmanagement/billing/limit/${buildQuery(companyId)}`, {
      monthly_limit: monthlyLimit,
    })
  },

  cancelSubscription(companyId = '') {
    return deleteRest(
      `/members-api/creditmanagement/billing/cancel-subscription/${buildQuery(companyId)}`
    )
  },
}

const creditsManagementAPI = USE_MOCK_API ? mockCreditManagementAPI : realAPI

export default creditsManagementAPI
export { USE_MOCK_API }
